jQuery(document).ready(function ($) {

    var averages = {};
    var averagesByControlTitles = {};
    var MaturityScoresOverall = {};
    var cleanedCategorizedScores = {};
	var areAveragesCalculated = false;
	var areAveragesByControlTitlesCalculated = false;
	var lastCalculatedStandard = null;
	var standardAveragesCache = {}; // Cache averages per standard
	var controlTitleAveragesCache = {}; // Cache control title averages

	if (!window.WebAssessmentCharts) {
		window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
	}

	// Now using utility function from prefixToDomainTitles.js
	WebAssessmentCharts.PrefixToDomainTitles = prefixToDomainTitles;

	// Now using utility function from updateDomainScoresInTable.js
	WebAssessmentCharts.updateDomainScoresInTable = updateDomainScoresInTable;
	
	// Now using utility function from updateLegacyDomainScoresInTable.js
	WebAssessmentCharts.updateLegacyDomainScoresInTable = updateLegacyDomainScoresInTable;
	
	// Now using utility function from calculateScoresByMappingPrefix.js
	WebAssessmentCharts.calculateScoresByMappingPrefix = calculateScoresByMappingPrefix;
	
	// Now using utility functions from legacyMaturityCalculations.js
	WebAssessmentCharts.calculateDirectLegacyMaturity = calculateDirectLegacyMaturity;
	WebAssessmentCharts.getLegacyPriorityMap = getLegacyPriorityMap;
	
	// Now using utility functions from standardsCalculations.js
	WebAssessmentCharts.NISTCSF11 = NISTCSF11;
	WebAssessmentCharts.NISTCSF2 = NISTCSF2;
	WebAssessmentCharts.CIS81 = CIS81;
	WebAssessmentCharts.CIS8 = CIS8;
	WebAssessmentCharts.CIS7 = CIS7;
	WebAssessmentCharts.ISO270022013 = ISO270022013;
	WebAssessmentCharts.ISO270022022 = ISO270022022;
	WebAssessmentCharts.NYCRR5002 = NYCRR5002;
	WebAssessmentCharts.FCARM2024 = FCARM2024;
	WebAssessmentCharts.UCIS3 = UCIS3;
	
	// Now using utility functions from frameworkAverages.js
	WebAssessmentCharts.calculateCISAverages = calculateCISAverages;
	WebAssessmentCharts.calculateNIST2Averages = calculateNIST2Averages;
	
	// Now using utility function from crfDomain.js
	WebAssessmentCharts.crfDomain = crfDomain;
	
	// Now using utility function from calculateAverageScoresByControlTitles.js
	WebAssessmentCharts.calculateAverageScoresByControlTitles = calculateAverageScoresByControlTitles;
	
	// Now using utility function from groupControlTitlesByStandard.js
	WebAssessmentCharts.groupControlTitlesByStandard = groupControlTitlesByStandard;
	
	// Now using utility functions from calculateMaturityScoresByLevel.js and calculateOverallMaturityScores.js
	WebAssessmentCharts.calculateMaturityScoresByLevelPerCategory = calculateMaturityScoresByLevelPerCategory;
	WebAssessmentCharts.calculateOverallMaturityScores = calculateOverallMaturityScores;
	
	// Now using utility function from fetchQualityData.js
	WebAssessmentCharts.fetchQualityData = fetchQualityData;
	
	// Now using utility function from calculateAverageMaturityScores.js
	WebAssessmentCharts.calculateAverageMaturityScores = calculateAverageMaturityScores;
	
	// Now using utility functions from extraction utilities
	WebAssessmentCharts.populateControlSets = populateControlSets;
	WebAssessmentCharts.extractAllCRFMappings = extractAllCRFMappings;
	WebAssessmentCharts.extractCRFMapping = extractCRFMapping;
	WebAssessmentCharts.extractAllCCCMappings = extractAllCCCMappings;
	WebAssessmentCharts.extractCCCMapping = extractCCCMapping;
	WebAssessmentCharts.extractUniqueControlValues = extractUniqueControlValues;
	WebAssessmentCharts.extractUniqueControlUIDsForAllStandards = extractUniqueControlUIDsForAllStandards;
	WebAssessmentCharts.extractUniqueStandardIDs = extractUniqueStandardIDs;
	WebAssessmentCharts.extractUniqueControlUIDsForStandard = extractUniqueControlUIDsForStandard;

	let projectID;
	if ($('body').hasClass('single-projects')) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}
	}

	//console.log('Extracted projectID:', projectID); // Verify the extracted project ID

	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;

	// State management for averages calculation
	const averagesState = {
		areAveragesCalculated: areAveragesCalculated,
		lastCalculatedStandard: lastCalculatedStandard
	};
	
	const controlTitleState = {
		areAveragesByControlTitlesCalculated: areAveragesByControlTitlesCalculated
	};

	// Wrapper function for calculateStandardSpecificAverages
	function calculateStandardSpecificAveragesWrapper(standardName) {
		averages = calculateStandardSpecificAverages(standardName, WebAssessmentCharts, standardAveragesCache, averagesState);
		// Update global state from the state object
		areAveragesCalculated = averagesState.areAveragesCalculated;
		lastCalculatedStandard = averagesState.lastCalculatedStandard;
	}

	// Wrapper function for calculateControlTitleAverages
	function calculateControlTitleAveragesWrapper() {
		averagesByControlTitles = calculateControlTitleAverages(WebAssessmentCharts, controlTitleAveragesCache, controlTitleState);
		// Update global state from the state object
		areAveragesByControlTitlesCalculated = controlTitleState.areAveragesByControlTitlesCalculated;
	}


	// Fetch project data and CRF data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		if ($('body').hasClass('single-projects')) {
			// Extract the URL path and split it to get the slug
			const pathParts = window.location.pathname.split('/projects/');
			if (pathParts.length > 1) {
				// Get the slug portion after '/projects/' and remove any trailing slash if present
				projectID = pathParts[1].split('/')[0];
			}
		}
		$('.dashboard-selection').next('.select2-container').show();
		$('.dashboards>div').hide();
		if ($('.dashboard-selection option:selected').text() === "Select Dashboard") {
			$('.select-a-dashboard').show();
		} else {
			$('.select-a-dashboard').hide();
		}
		$('.select-a-project').hide();
		try {
			const [projectData, qualityData] = await Promise.all([
				WebAssessmentCharts.fetchProjectChartData(projectID),
				WebAssessmentCharts.fetchQualityData("2025")
			]);
			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			const projectItems = projectData;
			//console.log('projectItems', projectItems);

		WebAssessmentCharts.qualityData = qualityData; // Store the raw quality data object
		WebAssessmentCharts.assessmentYear = "2025"; // Store the assessment year for mapping determination
		console.log('qualityData', qualityData);
			const qualityItems = WebAssessmentCharts.sortAndOrganizeItems(qualityData.CRF.Items);
			WebAssessmentCharts.qualityItems = qualityItems;
			const processedItems = WebAssessmentCharts.processUniqueItems(projectItems);
			WebAssessmentCharts.processedItems = processedItems;
			//console.log('original processedItems', WebAssessmentCharts.processedItems);

			await injectCrossFrameworkNA(processedItems, qualityItems, "2025");

			const scoresByTopicAndPriority = WebAssessmentCharts.calculateScoresByTopicAndPriority(processedItems, qualityItems);
			console.log('scoresByTopicAndPriority inside fetchDataAndCalculateScores', scoresByTopicAndPriority);

			const categorizedScores = WebAssessmentCharts.categorizeScores(scoresByTopicAndPriority, qualityItems, processedItems);
            console.log('categorizedScores inside fetchDataAndCalculateScores', categorizedScores);

			// Calculate maturity scores by level and get cleaned categorized scores
			const maturityResult = WebAssessmentCharts.calculateMaturityScoresByLevelPerCategory(categorizedScores);
			console.log('maturityResult inside fetchDataAndCalculateScores', maturityResult);
			const MaturityScoresByLevel = maturityResult.results;
            console.log('MaturityScoresByLevel inside fetchDataAndCalculateScores', MaturityScoresByLevel);
			cleanedCategorizedScores = maturityResult.cleanedCategorizedScores;

			// Create a deep copy of cleanedCategorizedScores
			WebAssessmentCharts.categorizedScoresCopy = maturityResult.cleanedCategorizedScores;
			WebAssessmentCharts.potentialItemCounts = maturityResult.potentialItemCounts;

			MaturityScoresOverall = WebAssessmentCharts.calculateOverallMaturityScores(MaturityScoresByLevel);
			WebAssessmentCharts.MaturityScoresOverall2025 = MaturityScoresOverall;
            //console.log('MaturityScoresOverall', MaturityScoresOverall);
		    WebAssessmentCharts.crfMaturityLevelScores(MaturityScoresOverall);
			//console.log('MaturityScoresByLevel', MaturityScoresByLevel);
			//console.log('processitems before crfDomain', processedItems);
			//console.log('qualityItems before crfDomain', qualityItems);
			WebAssessmentCharts.crfDomain(processedItems, qualityItems, false);

			// Calculate scores by mapping prefix for CRF dashboards
			if (qualityData && qualityData.Combined) {
				const scoresByMappingPrefix = WebAssessmentCharts.calculateScoresByMappingPrefix(processedItems, qualityData.Combined);
				WebAssessmentCharts.scoresByMappingPrefix = scoresByMappingPrefix; // Store on the namespace if needed elsewhere
				//console.log('Scores by Mapping Prefix:', scoresByMappingPrefix);
			} else {
				console.warn('qualityData.Combined not available for calculateScoresByMappingPrefix');
			}

			// Expensive calculations for other standards are now deferred to on-demand functions

			//$('.dashboard-selection').trigger('change');
			if ($('body').hasClass('single-projects') && $('body').hasClass('crf-s-2025')) {
					
				const $select = $('.dashboard-selection');
				if (!$select.length) {
					return;
				}

				// Find the index of the 2025 option
				let targetIndex = -1;
				$select.find('option').each(function(index) {
					if ($(this).text().includes('CRF-S (v2025)')) {
						targetIndex = index;
						return false;
					}
				});
				
				if (targetIndex !== -1) {
					try {
						// First ensure Select2 is initialized
						if (!$select.data('select2')) {
							$select.select2();
						}
						
						// Set the value
						$select.val('CRFS');
						
						// Set the selected index
						$select[0].selectedIndex = targetIndex;
						
						// Trigger the change events
						$select.trigger('change');
						$select.trigger('change.select2');
						
					} catch (error) {
						console.error('Error selecting 2025 version:', error);
					}
				} else {
					console.error('Could not find 2025 option in dropdown');
				}
			}
			//$('.dashboard-selection').show();
			$('.select-a-dashboard .loader').hide();
			$('.modal-body .loader').hide();
			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();

		} catch (error) {
			console.error('Error processing data:', error);
		}
	}

	WebAssessmentCharts.fetchDataAndCalculateScores2025 = WebAssessmentCharts.fetchDataAndCalculateScores;



	// Now using utility function from sortAndOrganizeItems.js
	WebAssessmentCharts.sortAndOrganizeItems = sortAndOrganizeItems;

	// Helper function to calculate maturity score based on policystatus
	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;

	// Now using utility function from processUniqueItems.js
	WebAssessmentCharts.processUniqueItems = processUniqueItems;

	// Now using utility function from normalizePriorityTag.js
	WebAssessmentCharts.normalizePriorityTag = normalizePriorityTag;

	// Now using utility function from categorizeScores.js
	WebAssessmentCharts.categorizeScores = categorizeScores;


	// Now using utility function from calculateScoresByTopicAndPriority.js
	WebAssessmentCharts.calculateScoresByTopicAndPriority = calculateScoresByTopicAndPriority;

	// Define the shared mapping at the top level
	const cccMapping = {
		'GOV': 'Governance',
		'THR': 'Threat Management',
		'POL': 'Security Policy Management',
		'EDU': 'Education and Awareness',
		'PM': 'Project Management',
		'CHM': 'Exception Management',
		'MET': 'Metrics Management',
		'AUD': 'Audit Management',
		'TPM': 'Third Party Management',
		'RR': 'Risk Reporting',
		'PER': 'Personnel Management',
		'PHY': 'Physical Security',
		'BCP': 'Business Continuity',
		'IM': 'Incident Management',
		'PRV': 'Privacy Management',
		'AID': 'Asset Inventory',
		'SID': 'Software Inventory',
		'AC': 'Application Control',
		'PAT': 'Patch Management',
		'VM': 'Vulnerability Management',
		'CM': 'Configuration Management',
		'END': 'Endpoint Protection',
		'REM': 'Removable Media Protection',
		'MDM': 'Mobile Device Protection',
		'MDM': 'Mobile Device Management',
		'BAC': 'Backup and Recovery',
		'LOG': 'Log Management',
		'FIM': 'File Integrity Management',
		'IDM': 'Identity Management',
		'ID': 'Identity Management',
		'DI': 'Data Inventory Management',
		'DTA': 'Data Management',
		'AM': 'Access Management',
		'PAM': 'Privileged Account Management',
		'NDM': 'Network Device Management',
		'BD': 'Boundary Filtering',
		'RA': 'Remote Access',
		'WF': 'Web Filtering',
		'EF': 'Email Filtering',
		'NSC': 'Network Segmentation',
		'WIR': 'Wireless',
		'SDS': 'Software Development',
		'SCA': 'Static Code Analysis',
		'PRG': 'Program Management',
		'SAF': 'Safeguard Selection Management',
		'AST': 'Asset Management',
		'IMP': 'Safeguard Implementation Management',
		'VAL': 'Safeguard Validation Management',
		'TPR': 'Third-Party Risk Management',
		'COM': 'Risk Communication Management',
		'RES': 'Resilience Management',
		'AI': 'Artificial Intelligence Management',
		'DTA': 'Data Inventory Management',
		'PRV': 'Data Privacy',
		'SYS': 'System Protection Management',
		'SW': 'Software Management',
		'CFG': 'Configuration Management',
		'VUL': 'Vulnerability Management',
		'PNA': 'Perimeter Network Access Management',
		'INA': 'Internal Network Access Management',
		'CSP': 'Cloud Service Provider Management',
		'EM': 'Email Management',
		'SDM': 'Software Development Standardization Management',
		'SDV': 'Software Development Vulnerability Management'
	};

	// Now using utility function from crfScope.js
	WebAssessmentCharts.crfScope = crfScope;

	// Now using utility function from crfImplementationMaturity.js
	WebAssessmentCharts.crfImplementationMaturity = crfImplementationMaturity;

	// Now using utility function from crfMaturityLevelScores.js
	WebAssessmentCharts.crfMaturityLevelScores = crfMaturityLevelScores;
	
	// Object to keep track of charts
	var charts = {};

	$('.project-selection').on('change', function () {
		var selectedProject = $(this).find('option:selected').val();
		var projectDate = $('.projects-modified-date.project-' + selectedProject).html();
		$('.modified-value').html(projectDate);
		$('.modified-date span').show();
		$('.dashboards>div').hide();
		WebAssessmentCharts.fetchDataAndCalculateScores(selectedProject);
	});

	$('.select2').each(function() {
		// If the element is inside the modal, set its dropdown parent accordingly
		var $this = $(this);
		var opts = {
		  templateResult: formatState,
		  minimumResultsForSearch: Infinity,
		  width: '300px'
		};
		if ($this.closest('#viewResultsModal').length) {
		  opts.dropdownParent = $('#viewResultsModal');
		}
		$this.select2(opts);
	  });
	  

	// Now using utility function from formatState.js
	WebAssessmentCharts.formatState = formatState;

	
	// Now using utility function from findRelatedControlItems.js
	WebAssessmentCharts.findRelatedControlItems = findRelatedControlItems;
	


	// Handle the change event
	$('.dashboard-selection').on('change', function () {
		var selectedDashboard = $(this).val();
		const selectedOptionText = $(this).find('option:selected').text();

		// Hide all dashboard containers and select-a-dashboard message
		$('.dashboards>div').hide();
		$('.select-a-dashboard').hide();

		switch (selectedDashboard) {
			case 'ISO2013':
				calculateStandardSpecificAveragesWrapper('ISO2013');
				WebAssessmentCharts.ISO270022013(averages, charts);
				break;
			case 'ISO2022':
				calculateStandardSpecificAveragesWrapper('ISO2022');
				WebAssessmentCharts.ISO270022022(averages, charts);
				break;
			case 'CRFS':
				console.log('Starting CRF calculations...');
				// Run these synchronously:
				WebAssessmentCharts.crfScope(WebAssessmentCharts.categorizedScoresCopy, WebAssessmentCharts.qualityItems);
				WebAssessmentCharts.crfImplementationMaturity(cleanedCategorizedScores);
				WebAssessmentCharts.crfMaturityLevelScores(MaturityScoresOverall);
				// AI category: show for 2025 and 2026 comparisons
				const is2025OrNewer = selectedOptionText.includes('2025') || selectedOptionText.includes('2026');
				if (is2025OrNewer) {
					$('.ai-management-row').not('.domain-all-na').show();
				} else {
					$('.ai-management-row').hide();
				}
				// SDO (Software Development Operations) category: show only for 2026 comparisons
				if (selectedOptionText.includes('2026')) {
					$('.sdo-management-row').not('.domain-all-na').show();
				} else {
					$('.sdo-management-row').hide();
				}

				console.log('All CRF calculations completed');
				$('.crf-legacy-container').hide();

				$('.crf-container').show();
				WebAssessmentCharts.createChartFromTable('scope', 'crf-scope-chart', charts, false);
				WebAssessmentCharts.createChartFromTable('technical', 'crf-technical-chart', charts, true);
				WebAssessmentCharts.createChartFromTable('maturity', 'crf-maturity-chart', charts, false);
				$('#viewResultsModal').modal('handleUpdate');
				break;
			case 'CRFS-LEGACY':
				console.log('Starting CRF LEGACY calculations...');

				// Calculate scores by mapping prefix just-in-time for legacy dashboards
				if (WebAssessmentCharts.qualityData && WebAssessmentCharts.qualityData.Combined) {
					const scoresByMappingPrefix = WebAssessmentCharts.calculateScoresByMappingPrefix(WebAssessmentCharts.processedItems, WebAssessmentCharts.qualityData.Combined);
					WebAssessmentCharts.scoresByMappingPrefix = scoresByMappingPrefix;
					console.log('DEBUG: Legacy scoresByMappingPrefix calculated:', scoresByMappingPrefix);
				} else {
					console.log('DEBUG: qualityData.Combined not available');
				}

				const yearMatch = selectedOptionText.match(/\(v(\d{4})\)/);

				if (yearMatch && yearMatch[1]) {
					const legacyYear = yearMatch[1];
					console.log(`Extracted legacy year: ${legacyYear}`);

					// Use the same calculation method as modern mode, but with isLegacyMode = true
					// This ensures consistency between modern and legacy calculations
					console.log('Calculating legacy maturity scores using same method as modern mode (with isLegacyMode=true)...');
					
					// Get legacy priority map for calculateScoresByTopicAndPriority
					const legacyPriorityMap = WebAssessmentCharts.getLegacyPriorityMap ? 
						WebAssessmentCharts.getLegacyPriorityMap(legacyYear, WebAssessmentCharts.qualityData) : null;
					
					// Calculate scores using the same method as modern mode
					const scoresByTopicAndPriority = WebAssessmentCharts.calculateScoresByTopicAndPriority(
						WebAssessmentCharts.processedItems, 
						WebAssessmentCharts.qualityItems, 
						true, // isLegacyMode
						legacyPriorityMap
					);
					console.log('Legacy scoresByTopicAndPriority calculated:', scoresByTopicAndPriority);

					const categorizedScores = WebAssessmentCharts.categorizeScores(
						scoresByTopicAndPriority, 
						WebAssessmentCharts.qualityItems, 
						WebAssessmentCharts.processedItems,
						true // isLegacyMode
					);
					console.log('Legacy categorizedScores calculated:', categorizedScores);

					// Calculate maturity scores by level using legacy mode
					const maturityResult = WebAssessmentCharts.calculateMaturityScoresByLevelPerCategory(categorizedScores, true);
					console.log('Legacy maturityResult calculated:', maturityResult);
					const MaturityScoresByLevel = maturityResult.results;
					
					// Store cleaned categorized scores for crfScope
					WebAssessmentCharts.categorizedScoresCopy = maturityResult.cleanedCategorizedScores;

					// Calculate overall maturity scores using legacy mode
					const legacyScores = WebAssessmentCharts.calculateOverallMaturityScores(MaturityScoresByLevel, true);
					console.log('Legacy scores calculated:', legacyScores);
					
					WebAssessmentCharts.crfMaturityLevelScores(legacyScores, true);
					
					// Recreate the maturity chart after the table has been updated
					console.log('Recreating legacy-maturity chart after scores update');
					WebAssessmentCharts.createChartFromTable('legacy-maturity', 'crf-legacy-maturity-chart', charts, false);
				} else {
					console.error('Could not extract year from selected legacy dashboard option:', selectedOptionText);
				}

				// Update table using CCC averages for legacy
				//console.log('DEBUG: scoresByMappingPrefix:', WebAssessmentCharts.scoresByMappingPrefix);
				//console.log('DEBUG: cccAverages:', WebAssessmentCharts.scoresByMappingPrefix?.cccAverages);
				if (WebAssessmentCharts.scoresByMappingPrefix && WebAssessmentCharts.scoresByMappingPrefix.cccAverages) {
					console.log('DEBUG: Calling updateLegacyDomainScoresInTable for legacy tables');
					WebAssessmentCharts.updateLegacyDomainScoresInTable('legacy-technical', WebAssessmentCharts.scoresByMappingPrefix.cccAverages);
					WebAssessmentCharts.updateLegacyDomainScoresInTable('legacy-scope', WebAssessmentCharts.scoresByMappingPrefix.cccAverages);
				} else {
					console.log('DEBUG: scoresByMappingPrefix or cccAverages not available');
				}


				//console.log('All CRF LEGACY calculations completed');
				$('.crf-container').hide();
				$('.crf-legacy-container').show();
				WebAssessmentCharts.createChartFromTable('legacy-scope', 'crf-legacy-scope-chart', charts, true);
				WebAssessmentCharts.createChartFromTable('legacy-technical', 'crf-legacy-technical-chart', charts, true); // Chart will be based on updated table
				//WebAssessmentCharts.createChartFromTable('legacy-maturity', 'crf-legacy-maturity-chart', charts, false); // Initial chart creation
				$('#viewResultsModal').modal('handleUpdate');
				break;								  
			case 'NIST11':
				calculateStandardSpecificAveragesWrapper('NIST11');
				WebAssessmentCharts.NISTCSF11(averages, charts);
				break;
			case 'NIST2':
				calculateStandardSpecificAveragesWrapper('NIST2');
				WebAssessmentCharts.NISTCSF2(averages, charts);
				break;
			case 'CIS7':
				calculateStandardSpecificAveragesWrapper('CIS7');
				WebAssessmentCharts.CIS7(averages, charts);
				break;
			case 'CIS8':
				calculateStandardSpecificAveragesWrapper('CIS8');
				WebAssessmentCharts.CIS8(averages, charts);
				break;
			case 'CIS81':
				calculateStandardSpecificAveragesWrapper('CIS81');
				WebAssessmentCharts.CIS81(averages, charts);
				break;
			case 'NYCRR2':
				calculateStandardSpecificAveragesWrapper('NYCRR2');
				WebAssessmentCharts.NYCRR5002(averages, charts);
				break;
			case 'FCARM2024':
				calculateControlTitleAveragesWrapper();
				WebAssessmentCharts.FCARM2024(averagesByControlTitles, charts);
				break;
			case 'UCIS3':
				calculateStandardSpecificAveragesWrapper('UCIS3');
				WebAssessmentCharts.UCIS3(averages, charts);
				break;
			case 'upgrade':
				if ($('#viewResultsModal').length) {
					$('#viewResultsModal').modal('hide');
				}
				setTimeout(function () {
					$('#upgradeModal').modal('show');
				}, 300);
				$('#upgradeModal').on('shown.bs.modal', function () {
					// Select 'CRFS' from the dropdown after the modal is fully visible
					$('.dashboard-selection').val('CRFS').trigger('change'); // Trigger 'change' event if needed
				});
				break;
			default:
				$('.select-a-dashboard').show();
				break;
		}
	});

	// Now using utility function from chartEventHandlers.js for view-table functionality
	// (CRFS-specific logic handled separately below)

	viewResultsProject = window.location.href;
	let currentProjectID = '';

	// Check if there's a hash in the URL
	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];

		// Only proceed if there is a value after the hash
		if (currentProjectID) {
			//console.log('Current Project ID from hash:', currentProjectID);

			// Trigger changes for project-selection and dashboard-selection
			$('.project-selection').val(currentProjectID).trigger('change');
			$('.dashboard-selection').val('CRFS').trigger('change');
		}
	}

	// Check if the body has class 'single-projects'
	if ($('body').hasClass('single-projects')) {

		// Extract the project ID from the URL path if it's not available from the hash
		if (!currentProjectID) {
			const projectPath = viewResultsProject.split('/projects/');
			if (projectPath.length > 1) {
				currentProjectID = projectPath[1].split('/')[0];  // Extract the part after '/projects/'
			}
		}

		const selectElement = $('.project-selection').eq(0);  // Adjust the index if needed (0 = first, 1 = second, etc.)

		// Find its corresponding select2 container and hide it
		const select2Container = selectElement.next('.select2-container');

		if (select2Container.length) {
			select2Container.hide();  // Hide the select2 dropdown
		}

		// Add logic to toggle the 'mt-5' class on the modal-content based on the dashboard selection
		$('.dashboard-selection').on('change', function () {
			const selectedValue = $(this).val();

			if (selectedValue === 'CRFS') {
				$('.modal-content').addClass('mt-5');  // Add 'mt-5' class if 'CRFS' is selected
			} else {
				$('.modal-content').removeClass('mt-5');  // Remove 'mt-5' class if anything else is selected
			}

			
		});

		// CRFS-specific view-results handler with additional logic
		// Note: The main .view-results handler is in chartEventHandlers.js
		// This is for CRFS-specific additional logic only
		$('.view-results').on('click', function () {
			// Select and trigger change for CRF-S option (CRFS-specific logic)
				$('.dashboard-selection').trigger('change');
		});

	}

	WebAssessmentCharts.crfMaturityLevelScores2025 = WebAssessmentCharts.crfMaturityLevelScores;

	// Now using utility function from chartEventHandlers.js
	if ($('body').hasClass('single-projects')) {
		initializeChartEventHandlers();
	}

});
